(() => {
  "use strict";

  const roots = document.querySelectorAll("[data-thong-set-mobile]");
  roots.forEach(init);

  function init(root) {
    if (root.dataset.tsmpReady === "true") return;
    root.dataset.tsmpReady = "true";

    const $ = (selector, scope = root) => scope.querySelector(selector);
    const $$ = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
    const configNode = $("[data-tsmp-products]");
    let products = {};
    try { products = JSON.parse(configNode.textContent); } catch (error) { showToast("Product options could not be loaded."); }

    const currency = root.dataset.currency || "AED";
    const freeShipping = Number(root.dataset.freeShipping);
    const announcement = $(".tsmp__announcement");
    const header = document.querySelector("#shopify-section-gnj-header");
    if (announcement && header) header.prepend(announcement);
    const state = { fit: "", pack: "", colour: "", size: "", variant: null, added: false, busy: false };
    const labels = {
      fit: { normal: "Normal Waist", hi: "Hi-Waist" },
      pack: { "1": "Single", "3": "3-Pack", "6": "6-Pack" },
      colour: { black: "Black", nude: "Nude", pink: "Pink", lavender: "Lavender", "misty-blue": "Misty Blue", bn: "Black & Nude", pa: "Summer Pastels" }
    };
    const packCounts = { "1": 1, "3": 3, "6": 6 };
    const colourHex = { black: "#211c16", nude: "#d7b69b", pink: "#f1c4cd", lavender: "#ccc0e6", "misty-blue": "#bbd1e1" };
    const paletteContents = {
      "3": {
        bn: ["nude", "black", "nude"],
        pa: ["misty-blue", "pink", "lavender"]
      },
      "6": {
        bn: ["nude", "black", "nude", "nude", "black", "nude"],
        pa: ["misty-blue", "pink", "lavender", "misty-blue", "pink", "lavender"]
      }
    };

    const money = cents => {
      const value = Number(cents || 0) / 100;
      return `${currency} ${value.toFixed(value % 1 ? 2 : 0)}`;
    };
    const normalise = value => String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
    const optionNames = product => (product && product.options || []).map(option => typeof option === "string" ? option : option.name);
    const optionIndex = (product, pattern) => optionNames(product).findIndex(name => pattern.test(String(name || "")));
    const optionValue = (variant, index) => index >= 0 ? (variant.options || [])[index] : "";
    const paletteFor = colour => ["black", "nude", "bn"].includes(colour) ? "Black & Nude" : "Summer Pastels";
    const packMatches = (value, pack) => {
      const clean = normalise(value);
      if (pack === "1") return clean === "single" || clean === "1" || clean === "1pack";
      return clean.includes(pack) && (clean.includes("pack") || clean === pack);
    };
    const compositionFor = (pack, colour) => pack === "1" ? [colour] : (paletteContents[pack] && paletteContents[pack][colour] || []);
    const groupedComposition = items => items.reduce((groups, key) => {
      const match = groups.find(group => group.key === key);
      if (match) match.count += 1; else groups.push({ key, count: 1 });
      return groups;
    }, []);
    const breakdownFor = items => groupedComposition(items).map(group => `${group.count} ${labels.colour[group.key]}`).join(" · ");

    function imageSource(image) {
      const source = image && (image.src || image.url || image);
      if (!source || typeof source !== "string") return "";
      return source.indexOf("//") === 0 ? `https:${source}` : source;
    }

    function colourImage(fit, colour) {
      const overrides = products.colourImages && products.colourImages[fit];
      if (overrides && colour && typeof overrides[colour] === "string" && overrides[colour]) return imageSource(overrides[colour]);
      const product = products.colourProducts && products.colourProducts[fit];
      if (!product || !colour) return "";
      const colourIndex = optionIndex(product, /colou?r/i);
      const wanted = normalise(labels.colour[colour]);
      const variant = (product.variants || []).find(candidate => {
        const option = colourIndex >= 0 ? optionValue(candidate, colourIndex) : candidate.title;
        return normalise(option).indexOf(wanted) === 0 && imageSource(candidate.featured_image);
      });
      return imageSource(variant && variant.featured_image) || imageSource(product.featured_image);
    }

    function variantsFor(fit) {
      return products[fit] && Array.isArray(products[fit].variants) ? products[fit].variants : [];
    }

    function findVariant(fit, pack, colour, size) {
      const product = products[fit];
      if (!product || !pack || !colour || !size) return null;
      const colourIndex = optionIndex(product, /colou?r/i);
      const packIndex = optionIndex(product, /pack|set/i);
      const sizeIndex = optionIndex(product, /size/i);
      const palette = paletteFor(colour);
      return variantsFor(fit).find(variant => {
        const colourOkay = colourIndex < 0 || normalise(optionValue(variant, colourIndex)) === normalise(palette);
        const packOkay = packIndex < 0 ? normalise(variant.title).includes(normalise(labels.pack[pack])) : packMatches(optionValue(variant, packIndex), pack);
        const sizeOkay = sizeIndex < 0 || normalise(optionValue(variant, sizeIndex)) === normalise(size);
        return colourOkay && packOkay && sizeOkay;
      }) || null;
    }

    function firstVariantForPack(fit, pack) {
      const product = products[fit];
      if (!product) return null;
      const packIndex = optionIndex(product, /pack|set/i);
      const matches = variantsFor(fit).filter(variant => packIndex < 0 ? normalise(variant.title).includes(normalise(labels.pack[pack])) : packMatches(optionValue(variant, packIndex), pack));
      return matches.find(variant => variant.available) || matches[0] || null;
    }

    function lowestPrice() {
      const values = Object.keys(products).flatMap(key => variantsFor(key)).filter(variant => variant.available).map(variant => Number(variant.price));
      return values.length ? Math.min.apply(Math, values) : 0;
    }

    function firstMissing() {
      return ["fit", "pack", "colour", "size"].find(key => !state[key]);
    }

    function choiceLabel(key) {
      if (!state[key]) return "Choose";
      if (key === "size") return state.size;
      return labels[key][state[key]] || state[key];
    }

    function track(event, extra) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({
        event,
        ecommerce: { currency, value: state.variant ? Number(state.variant.price) / 100 : undefined }
      }, extra || {}));
    }

    function renderPackPricing() {
      const fit = state.fit || "normal";
      ["1", "3", "6"].forEach(pack => {
        const variant = firstVariantForPack(fit, pack);
        const priceNode = $(`[data-tsmp-pack-price="${pack}"]`);
        if (priceNode) priceNode.textContent = variant ? `${state.fit ? "" : "From "}${money(variant.price)}` : "Unavailable";
        const metaNode = $(`[data-tsmp-pack-meta="${pack}"]`);
        if (!metaNode || !variant) return;
        const compare = Number(variant.compare_at_price || 0);
        const saving = Math.max(0, compare - Number(variant.price));
        metaNode.textContent = `${saving ? `Save ${money(saving)} · ` : ""}${money(Number(variant.price) / Number(pack))}/pair`;
      });
    }

    function renderColourMode() {
      const exact = $("[data-tsmp-exact-options]");
      const palettes = $("[data-tsmp-palette-options]");
      const help = $("[data-tsmp-colour-help]");
      exact.hidden = state.pack !== "1";
      palettes.hidden = !state.pack || state.pack === "1";
      if (!state.pack) help.textContent = "Select a pack first to see the right colour choices.";
      else if (state.pack === "1") help.textContent = "Choose the exact colour we should pack.";
      else help.textContent = "Choose a colourway. The dots show every pair included.";
      $$('[data-tsmp-palette-options] input').forEach(input => {
        const items = compositionFor(state.pack, input.value);
        const card = input.closest("label");
        const swatches = card.querySelector(".tsmp__swatches");
        const count = card.querySelector("[data-tsmp-colour-count]");
        swatches.innerHTML = items.map(key => `<i style="--swatch:${colourHex[key]}" title="${labels.colour[key]}"></i>`).join("");
        count.textContent = items.length ? breakdownFor(items) : "";
      });
      const selected = $("[data-tsmp-selected-colour]");
      selected.hidden = !state.colour;
      selected.textContent = state.colour ? `${state.pack === "1" ? "Colour" : "Colourway"}: ${choiceLabel("colour")}` : "";
    }

    function renderContents() {
      const node = $("[data-tsmp-contents]");
      if (!state.pack || !state.colour) { node.hidden = true; return; }
      const items = compositionFor(state.pack, state.colour);
      const groups = groupedComposition(items);
      const fit = state.fit || "normal";
      node.hidden = false;
      node.innerHTML = `
        <div><strong>Inside your ${labels.pack[state.pack]}</strong><span>${breakdownFor(items)}</span></div>
        <div class="tsmp__contents-thumbs">${groups.map(group => `<figure><span class="tsmp__contents-image"><img src="${colourImage(fit, group.key)}" alt="${labels.fit[fit]} ${labels.colour[group.key]} thong" loading="lazy"><b aria-label="${group.count} ${group.count === 1 ? "pair" : "pairs"}">×${group.count}</b></span><figcaption>${labels.colour[group.key]}</figcaption></figure>`).join("")}</div>`;
    }

    function renderRange() {
      const grid = $("[data-tsmp-range-grid]");
      const fit = state.fit || "normal";
      if (!grid || grid.dataset.fit === fit) return;
      grid.dataset.fit = fit;
      grid.innerHTML = Object.keys(colourHex).map(key => `<figure><img src="${colourImage(fit, key)}" alt="${labels.fit[fit]} thong in ${labels.colour[key]}" loading="lazy" width="440" height="550"><figcaption>${labels.colour[key]}</figcaption></figure>`).join("");
      $("[data-tsmp-range-caption]").textContent = `${labels.fit[fit]} · Five colours, sold singly or in palettes`;
      $("[data-tsmp-range-thumb]").src = colourImage(fit, "pink");
    }

    function renderGallerySelection() {
      renderRange();
      const slide = $("[data-tsmp-product-slide]");
      const image = slide.querySelector(":scope > img");
      const grid = $("[data-tsmp-product-grid]");
      const caption = $("[data-tsmp-product-caption]");
      const gallery = $("[data-tsmp-gallery]");
      const heroVideo = slide.querySelector("video");
      if (!state.fit && !state.colour) {
        if (heroVideo) heroVideo.play().catch(() => {});
        image.hidden = false;
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.src = slide.dataset.tsmpDefaultSrc;
        image.alt = "The Thong Set worn under a fitted outfit";
        grid.hidden = true;
        grid.innerHTML = "";
        slide.classList.remove("is-product-view");
        caption.textContent = "Invisible under clothes. Comfortable all day.";
        const thumb = $("[data-tsmp-gallery-thumb-current]");
        if (thumb) thumb.src = slide.dataset.tsmpDefaultSrc;
        $$("img", gallery).forEach(item => {
          item.tabIndex = 0;
          item.setAttribute("role", "button");
          item.setAttribute("aria-label", `Zoom ${item.alt}`);
        });
        return;
      }
      if (heroVideo) heroVideo.pause();
      const fit = state.fit || "normal";
      const keys = state.colour && state.pack !== "1" ? groupedComposition(compositionFor(state.pack, state.colour)) : [{ key: state.colour || "black", count: 1 }];
      slide.classList.add("is-product-view");
      if (keys.length === 1) {
        image.hidden = false;
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.src = colourImage(fit, keys[0].key);
        image.alt = `${labels.fit[fit]} thong in ${labels.colour[keys[0].key]}`;
        grid.hidden = true;
        grid.innerHTML = "";
        caption.textContent = `${labels.fit[fit]} · Colour: ${labels.colour[keys[0].key]}`;
      } else {
        image.hidden = true;
        grid.hidden = false;
        grid.innerHTML = keys.map(group => `<figure><img src="${colourImage(fit, group.key)}" alt="${labels.fit[fit]} thong in ${labels.colour[group.key]}"><figcaption>${labels.colour[group.key]}${group.count > 1 ? ` ×${group.count}` : ""}</figcaption></figure>`).join("");
        caption.textContent = `${labels.fit[fit]} · Colourway: ${choiceLabel("colour")}`;
      }
      const thumb = $("[data-tsmp-gallery-thumb-current]");
      if (thumb && keys[0]) thumb.src = colourImage(fit, keys[0].key);
      $$("img", gallery).forEach(item => {
        item.tabIndex = 0;
        item.setAttribute("role", "button");
        item.setAttribute("aria-label", `Zoom ${item.alt}`);
      });
      if (gallery) gallery.scrollLeft = 0;
    }

    function sizeAvailable(size) {
      if (!state.fit || !state.pack || !state.colour) return true;
      const variant = findVariant(state.fit, state.pack, state.colour, size);
      return Boolean(variant && variant.available);
    }

    function renderSizes() {
      const unavailable = [];
      $$("[data-tsmp-sizes] label").forEach(label => {
        const input = $("input", label);
        const available = sizeAvailable(input.value);
        input.disabled = !available;
        label.classList.toggle("is-unavailable", !available);
        $("small", label).textContent = "";
        if (!available) unavailable.push(input.value);
        if (!available && input.checked) {
          input.checked = false;
          state.size = "";
        }
      });
      const stockHelp = $("[data-tsmp-size-stock-help]");
      stockHelp.hidden = unavailable.length === 0;
      stockHelp.textContent = unavailable.length ? `${unavailable.join(", ")} sold out for this colour · notify me` : "";
    }

    function updateVariant() {
      state.variant = findVariant(state.fit, state.pack, state.colour, state.size);
      const idInput = $("[data-tsmp-variant-id]");
      if (state.variant) idInput.value = state.variant.id;
      const exactInput = $("[data-tsmp-exact-colour]");
      const exact = state.pack === "1" ? choiceLabel("colour") : "";
      exactInput.value = exact;
      exactInput.disabled = !exact;
    }

    function renderSummary() {
      const parts = ["fit", "colour", "pack", "size"].map(key => state[key] ? choiceLabel(key) : `Choose ${key}`);
      const summary = parts.join(" · ");
      $("[data-tsmp-summary]").textContent = summary;
      $("[data-tsmp-sticky-summary]").textContent = summary;
      const current = state.variant ? Number(state.variant.price) : 0;
      const preview = current || (state.fit && state.pack && firstVariantForPack(state.fit, state.pack) ? Number(firstVariantForPack(state.fit, state.pack).price) : 0);
      $("[data-tsmp-summary-price]").textContent = preview ? money(preview) : "—";
      $("[data-tsmp-sticky-price]").textContent = preview ? money(preview) : `From ${money(lowestPrice())}`;
      $("[data-tsmp-top-price]").textContent = preview ? money(preview) : money(lowestPrice());
      $("[data-tsmp-price-prefix]").textContent = preview ? "" : "From";
      const compare = state.variant ? Number(state.variant.compare_at_price || 0) : 0;
      const compareNode = $("[data-tsmp-compare]");
      compareNode.hidden = !compare;
      compareNode.textContent = compare ? money(compare) : "";
    }

    function renderPaymentAndShipping() {
      const candidate = state.variant || (state.fit && state.pack ? firstVariantForPack(state.fit, state.pack) : null);
      const current = candidate ? Number(candidate.price) : 0;
      const tabby = $("[data-tsmp-tabby]");
      tabby.hidden = !current;
      $("[data-tsmp-tabby-amount]").textContent = current ? money(current / 4) : "";
      const goal = $("[data-tsmp-ship-goal]");
      goal.hidden = !current;
      if (!current) return;
      const remaining = Math.max(0, freeShipping - current);
      $("[data-tsmp-ship-copy]").textContent = remaining ? `${money(remaining)} to free worldwide shipping · ${money(freeShipping)} threshold` : `Free worldwide shipping unlocked · ${money(freeShipping)} threshold`;
      $("[data-tsmp-ship-value]").textContent = remaining ? `${Math.round(current / freeShipping * 100)}%` : "Unlocked";
      $("[data-tsmp-ship-fill]").style.width = `${Math.min(100, current / freeShipping * 100)}%`;
    }

    function ctaText(sticky) {
      const missing = firstMissing();
      if (missing) return `Choose ${missing}`;
      if (!state.variant) return sticky ? "Unavailable" : "Combination unavailable";
      if (!state.variant.available) return sticky ? "Notify me" : `Notify me · Size ${state.size}`;
      if (state.added) return sticky ? "View bag" : "Added · View bag";
      return sticky ? "Add to bag" : `Add to bag · ${money(state.variant.price)}`;
    }

    function updateWhatsAppLinks() {
      const selection = ["fit", "pack", "colour", "size"]
        .filter(key => state[key])
        .map(key => `${key}: ${choiceLabel(key)}`)
        .join(" · ");
      const message = selection
        ? `Hi! I need size help with The Thong Set. My current selection is ${selection}.`
        : "Hi! I need size help with The Thong Set.";
      $$('[data-tsmp-whatsapp-context]').forEach(link => { link.href = `https://wa.me/971542332131?text=${encodeURIComponent(message)}`; });
    }

    function render() {
      ["fit", "pack", "colour", "size"].forEach(key => { $(`[data-tsmp-choice="${key}"]`).textContent = choiceLabel(key); });
      renderPackPricing();
      renderColourMode();
      renderContents();
      renderGallerySelection();
      renderSizes();
      updateVariant();
      renderSummary();
      renderPaymentAndShipping();
      $("[data-tsmp-add]").textContent = ctaText(false);
      $("[data-tsmp-sticky-add]").textContent = ctaText(true);
      updateWhatsAppLinks();
    }

    function select(key, value) {
      state.added = false;
      if (key === "pack" && state.pack !== value) {
        state.colour = "";
        $$('input[name^="tsmp-colour-"]').forEach(input => { input.checked = false; });
      }
      state[key] = value;
      if (key !== "size" && state.size && !sizeAvailable(state.size)) {
        state.size = "";
        const selectedSize = $('input[name^="tsmp-size-"]:checked');
        if (selectedSize) selectedSize.checked = false;
      }
      const eventName = { fit: "fit_selected", pack: "pack_selected", colour: "colour_selected", size: "size_selected" }[key];
      track(eventName, { selection: value });
      render();
    }

    function nudgeMissing() {
      const missing = firstMissing();
      if (!missing) return false;
      const step = $(`[data-tsmp-step="${missing}"]`);
      step.scrollIntoView({ behavior: "smooth", block: "center" });
      window.setTimeout(() => step.focus({ preventScroll: true }), 350);
      return true;
    }

    function showToast(message) {
      const node = $("[data-tsmp-toast]");
      node.textContent = message;
      node.classList.add("is-visible");
      window.clearTimeout(showToast.timer);
      showToast.timer = window.setTimeout(() => node.classList.remove("is-visible"), 2600);
    }

    function syncDialogState() {
      document.body.classList.toggle("tsmp-dialog-open", Boolean(root.querySelector("dialog[open]")));
    }

    function openDialog(dialog) {
      if (typeof dialog.showModal === "function") dialog.showModal(); else dialog.setAttribute("open", "");
      syncDialogState();
    }

    function closeDialog(dialog) {
      if (typeof dialog.close === "function") dialog.close(); else dialog.removeAttribute("open");
      syncDialogState();
    }

    function shippingCopy(total) {
      return total >= freeShipping ? `Free worldwide shipping unlocked · ${money(freeShipping)} threshold · 30-day exchange` : `${money(freeShipping - total)} to free worldwide shipping · ${money(freeShipping)} threshold · 30-day exchange`;
    }

    function openCart() {
      openDialog($("[data-tsmp-cart]"));
    }

    async function addToBag() {
      if (state.added) { openCart(); return; }
      if (nudgeMissing() || state.busy) return;
      if (!state.variant || !state.variant.available) {
        showToast("This combination is currently unavailable.");
        return;
      }

      state.busy = true;
      const buttons = [$("[data-tsmp-add]"), $("[data-tsmp-sticky-add]")];
      buttons.forEach(button => { button.disabled = true; button.textContent = "Adding…"; });
      const exact = state.pack === "1" ? choiceLabel("colour") : "";
      const payload = { id: state.variant.id, quantity: 1, properties: { _gnj_shipping_threshold: String(freeShipping) } };
      if (exact) payload.properties["Exact colour"] = exact;

      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error("Add to cart failed");
        const summary = `${choiceLabel("fit")} · ${choiceLabel("colour")} · ${choiceLabel("pack")} · Size ${state.size}`;
        $("[data-tsmp-cart-summary]").textContent = summary;
        $("[data-tsmp-cart-price]").textContent = money(state.variant.price);
        // Use the live bag total so the subtotal and free-shipping copy include anything already in the bag.
        let bagTotal = Number(state.variant.price);
        let bagCount = 1;
        try {
          const cartUrl = (root.dataset.cartUrl || "/cart").replace(/\/$/, "") + ".js";
          const bag = await fetch(cartUrl, { headers: { "Accept": "application/json" } }).then(r => r.ok ? r.json() : null);
          if (bag && typeof bag.total_price === "number") { bagTotal = bag.total_price; bagCount = bag.item_count || 1; }
        } catch (error) { /* fall back to the line price */ }
        $("[data-tsmp-cart-subtotal]").textContent = money(bagTotal);
        $("[data-tsmp-cart-shipping]").textContent = shippingCopy(bagTotal);
        const countLabel = $("[data-tsmp-cart-count]");
        if (countLabel) countLabel.textContent = bagCount > 1 ? ` (${bagCount})` : "";
        const cartColour = compositionFor(state.pack, state.colour)[0];
        const image = colourImage(state.fit, cartColour) || imageSource(state.variant.featured_image);
        $("[data-tsmp-cart-image]").src = image;
        $("[data-tsmp-cart-image]").alt = `${labels.fit[state.fit]} thong in ${labels.colour[cartColour]}`;
        state.added = true;
        track("thong_set_add_to_cart", { ecommerce: { currency, value: Number(state.variant.price) / 100, items: [{ item_id: String(state.variant.id), item_name: "The Thong Set", item_variant: summary, price: Number(state.variant.price) / 100, quantity: 1 }] } });
        render();
        openCart();
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } catch (error) {
        showToast("We couldn’t add that set. Please try again.");
      } finally {
        state.busy = false;
        buttons.forEach(button => { button.disabled = false; });
        render();
      }
    }

    function initGallery() {
      const gallery = $("[data-tsmp-gallery]");
      const slides = $$(".tsmp__slide", gallery);
      const dots = $$('[data-tsmp-gallery-dot]');
      const setSlide = index => {
        dots.forEach((dot, dotIndex) => dot.classList.toggle("is-active", dotIndex === index));
        $("[data-tsmp-slide-count]").textContent = `${index + 1} / ${slides.length}`;
      };
      gallery.addEventListener("scroll", () => setSlide(Math.round(gallery.scrollLeft / gallery.clientWidth)), { passive: true });
      dots.forEach((dot, index) => dot.addEventListener("click", () => gallery.scrollTo({ left: index * gallery.clientWidth, behavior: "smooth" })));
      const lightbox = $("[data-tsmp-lightbox]");
      const openZoom = image => {
        $("[data-tsmp-lightbox-image]").src = image.currentSrc || image.src;
        $("[data-tsmp-lightbox-image]").alt = image.alt;
        const caption = image.closest("figure")?.querySelector("figcaption");
        $("[data-tsmp-lightbox-caption]").textContent = caption ? (caption.children.length ? Array.from(caption.children).map(node => node.textContent.trim()).filter(Boolean).join(" · ") : caption.textContent.trim()) : image.alt;
        openDialog(lightbox);
      };
      const zoomables = [gallery, $("[data-tsmp-lookbook]")].filter(Boolean);
      zoomables.forEach(scope => {
        scope.addEventListener("click", event => { if (event.target.matches("img")) openZoom(event.target); });
        scope.addEventListener("keydown", event => {
          if (!event.target.matches("img") || !["Enter", " "].includes(event.key)) return;
          event.preventDefault();
          openZoom(event.target);
        });
      });
      $$("[data-tsmp-lookbook] img").forEach(item => {
        item.tabIndex = 0;
        item.setAttribute("role", "button");
        item.setAttribute("aria-label", `Zoom ${item.alt}`);
      });
      $$("[data-tsmp-scroll-builder]").forEach(button => button.addEventListener("click", () => {
        $("[data-tsmp-step=fit]").scrollIntoView({ behavior: "smooth", block: "start" });
        track("lookbook_build_cta");
      }));
    }

    function initSticky() {
      const sticky = $("[data-tsmp-sticky]");
      const builder = $("[data-tsmp-form]");
      const update = () => {
        const rect = builder.getBoundingClientRect();
        const entered = rect.top < window.innerHeight * .72 && rect.bottom > 90;
        sticky.classList.toggle("is-visible", entered && !document.body.classList.contains("tsmp-dialog-open"));
      };
      document.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    }

    $$('input[name^="tsmp-fit-"]').forEach(input => input.addEventListener("change", event => select("fit", event.target.value)));
    $$('input[name^="tsmp-pack-"]').forEach(input => input.addEventListener("change", event => select("pack", event.target.value)));
    $$('input[name^="tsmp-colour-"]').forEach(input => input.addEventListener("change", event => select("colour", event.target.value)));
    $$('input[name^="tsmp-size-"]').forEach(input => input.addEventListener("change", event => select("size", event.target.value)));

    const form = $("[data-tsmp-form]");
    form.addEventListener("submit", event => { event.preventDefault(); addToBag(); });
    $("[data-tsmp-add]").addEventListener("click", addToBag);
    $("[data-tsmp-sticky-add]").addEventListener("click", addToBag);

    const sizeSheet = $("[data-tsmp-size-sheet]");
    const lightbox = $("[data-tsmp-lightbox]");
    $$('[data-tsmp-open-size]').forEach(button => button.addEventListener("click", () => openDialog(sizeSheet)));
    $("[data-tsmp-close-size]").addEventListener("click", () => closeDialog(sizeSheet));
    sizeSheet.addEventListener("click", event => { if (event.target === sizeSheet) closeDialog(sizeSheet); });
    sizeSheet.addEventListener("cancel", event => { event.preventDefault(); closeDialog(sizeSheet); });

    $("[data-tsmp-close-lightbox]").addEventListener("click", () => closeDialog(lightbox));
    lightbox.addEventListener("click", event => { if (event.target === lightbox) closeDialog(lightbox); });
    lightbox.addEventListener("cancel", event => { event.preventDefault(); closeDialog(lightbox); });

    const cart = $("[data-tsmp-cart]");
    $$('[data-tsmp-close-cart]').forEach(button => button.addEventListener("click", () => closeDialog(cart)));
    cart.addEventListener("click", event => { if (event.target === cart) closeDialog(cart); });
    cart.addEventListener("cancel", event => { event.preventDefault(); closeDialog(cart); });
    $("[data-tsmp-edit]").addEventListener("click", () => { closeDialog(cart); $("[data-tsmp-step=fit]").scrollIntoView({ behavior: "smooth", block: "start" }); });
    $("[data-tsmp-checkout]").addEventListener("click", () => track("checkout_started"));
    [sizeSheet, cart, lightbox].forEach(dialog => dialog.addEventListener("close", syncDialogState));
    root.addEventListener("keydown", event => {
      if (event.key !== "Escape") return;
      if (cart.open) closeDialog(cart);
      else if (sizeSheet.open) closeDialog(sizeSheet);
      else if (lightbox.open) closeDialog(lightbox);
    });

    initGallery();
    initSticky();
    render();
    track("thong_set_view", { ecommerce: { currency, value: lowestPrice() / 100, items: [{ item_name: "The Thong Set", price: lowestPrice() / 100 }] } });
  }
})();


